import RoutesMap from "../../route_control/RouteControl"
import {
    CountryList,
    StateList,
    CityList,
    DepartmentList,
    DesignationList,
    LocationList,
    ComponentList,
    MakeList,
    EquipmentList,
    EquipmentAssignList,
    ObjectConditionList,
    ObjectList,
} from "../../pages/master"

export const MasterImport = {
    RoutesMap,
    CountryList,
    StateList,
    CityList,
    DepartmentList,
    DesignationList,
    LocationList,
    ComponentList,
    MakeList,
    EquipmentList,
    EquipmentAssignList,
    ObjectConditionList,
    ObjectList,
}